/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Side_RightInputs */

const en_us2_profile_side_right = /** @type {(inputs: Profile_Side_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`right`)
};

const pt_br2_profile_side_right = /** @type {(inputs: Profile_Side_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`direito`)
};

const es_419_profile_side_right = /** @type {(inputs: Profile_Side_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`derecho`)
};

const pt_pt2_profile_side_right = /** @type {(inputs: Profile_Side_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`direito`)
};

const fr_fr2_profile_side_right = /** @type {(inputs: Profile_Side_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`droit`)
};

const de_de2_profile_side_right = /** @type {(inputs: Profile_Side_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rechts`)
};

const it_it2_profile_side_right = /** @type {(inputs: Profile_Side_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`destro`)
};

/**
* | output |
* | --- |
* | "right" |
*
* @param {Profile_Side_RightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_side_right = /** @type {((inputs?: Profile_Side_RightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Side_RightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_side_right(inputs)
	if (locale === "es-419") return es_419_profile_side_right(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_side_right(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_side_right(inputs)
	if (locale === "de-DE") return de_de2_profile_side_right(inputs)
	if (locale === "it-IT") return it_it2_profile_side_right(inputs)
	return en_us2_profile_side_right(inputs)
});
export { profile_side_right as "profile.side_right" }